import {
  FastLinkMenuItemModel,
  FastLinkMenuModel,
} from '../../fastLinksMenu.model';

export const getFastlinksRows = (
  activeSphere: FastLinkMenuModel
): FastLinkMenuItemModel[][] =>
  activeSphere.fastlinks.reduce((acc: FastLinkMenuItemModel[][], _, i) => {
    if (i % 2 === 0) {
      acc.push(activeSphere.fastlinks.slice(i, i + 2));
    }

    return acc;
  }, []);
